import { useEffect } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EmptyState, ListSkeleton, PageBody, PageHeader } from "@/components/shell/page";
import {
  ProjectContext,
  lastVisited,
  useWorkspace,
} from "@/components/shell/workspace-context";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug")({
  component: ProjectLayout,
});

function ProjectLayout() {
  const { t } = useTranslation("shell");
  const { projectSlug } = Route.useParams();
  const { workspace, projects } = useWorkspace();
  const project = projects?.find((item) => item.slug === projectSlug);

  useEffect(() => {
    if (project) lastVisited.setProject(workspace._id, project.slug);
  }, [workspace._id, project]);

  if (projects === undefined) {
    return (
      <>
        <PageHeader title="" />
        <PageBody>
          <ListSkeleton />
        </PageBody>
      </>
    );
  }

  if (!project) {
    return (
      <>
        <PageHeader title={t("projectNotFound.title")} />
        <PageBody>
          <EmptyState title={t("projectNotFound.body")} />
        </PageBody>
      </>
    );
  }

  return (
    <ProjectContext.Provider value={project}>
      <Outlet />
    </ProjectContext.Provider>
  );
}
